import type { IMemberResponseBody } from '../../../types/response/IMemberResponseBody';

export class SimpleMember {
  constructor(
    private readonly _name: string,
    private readonly _memberId: string
  ) {}

  get name(): string {
    return this._name;
  }

  get memberId(): string {
    return this._memberId;
  }

  static fromResponse(response: IMemberResponseBody): SimpleMember {
    return new SimpleMember(response.name, response.memberId);
  }
}
